import React from "react";
import styles from './quoatation.module.scss';
import { Alert } from 'antd'


const QuotationApproved = () => {
    return <div className={styles.container}>
   <Alert message="Quotation Approved" description='Your Quotation has been aproved, wait for Leoprinting to notify about starting production' 
        type="success"
         />

    </div>
}
export default QuotationApproved